import { FC } from "react";
import { CommonProjectForm } from "./CommonProjectForm";

export const CreateGFAProjectForm: FC = () => {
	return (
		<CommonProjectForm
			projectId={undefined}
			projectType="gfa"
			GFAFullDetails={undefined}
		/>
	);
};
